<template>
  <section class="noti-wrapper">
    <BaseLoading  opaque :spinning="notificationsLoading">
      <div class="container">
        <SectionHeader :title="title" />
        <div class="noti-list-wrapper" v-if="!isUpgradeNotification">
          <a-pagination
            v-if="systemNotiMeta.total"
            class="system-pagination-wrapper"
            :total="systemNotiMeta.total"
            v-model="systemPage"
            @change="dispatcher"
            :defaultPageSize="25"
          /> 
          <h3 v-else class="no-notification-class">No Notifications Available</h3>
          <div class="noti-list" v-for="(item, index) in filteredNotifications" :key="index" >
            <div class="head-divider">
              {{ item.createdAt }}
            </div>
            <NotiDetail
              v-for="(list, i) in item.list"
              :key="i"
              :classlist="{ unread: !list.isRead }"
              :list="list"
            />
          </div>
        </div>
        <div class="noti-list-wrapper" v-if="isUpgradeNotification">
          <a-pagination
            v-if="upgradeNotiMeta.total"
            :total="upgradeNotiMeta.total"
            v-model="upgradePage"
            @change="dispatcher"
            :defaultPageSize="25"
            class="upgrade-pagination-wrapper"
          /> 
          <h3 v-else class="no-notification-class">No Notifications Available</h3>
          <div class="switch-wrapper" v-if="onlyPlayer()">
            <p>Automatic Renewal Notifications</p>
            <a-popconfirm
              id="pop-confirm"
              :title="checked ? 'Are you sure ? You will no longer receive upgrade notifications unless you turn back it on.' : 'Turning this on will allow you to receive upgrade notifications.'"
              @confirm="onSwitchChange"
              ok-text="Yes"
              cancel-text="No"
            >
              <a-switch default-checked :checked="checked"/>
            </a-popconfirm>
          </div>  
          <div class="noti-list" v-for="(item, index) in filteredUpgradeNotifications" :key="index" >
            <div class="head-divider">
              {{ item.createdAt }}
            </div>
            <NotiDetail
              v-for="(list, i) in item.list"
              :key="i"
              :classlist="{ unread: !list.isRead }"
              :list="list"
              :is-upgrade-notification="true"
            />
          </div>
        </div>
      </div>
    </BaseLoading>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import NotiDetail from "./noti-detail";
const NOTIFICATION_STORE = "notificationStore"
const ATHLETE_STORE = "athleteStore"

import { mapGetters } from "vuex"
import { Base } from "@/models"

export default {
  name: "Notifications",
  props: ["title", "data"],
  data() {
    return {
      checked: true,
      systemPage: 1,
      upgradePage: 1,
    }
  },
  components: {
    SectionHeader,
    NotiDetail
  },
  computed: {
    ...mapGetters({
      filteredNotifications: `${NOTIFICATION_STORE}/filteredNotifications`,
      filteredUpgradeNotifications: `${NOTIFICATION_STORE}/filteredUpgradeNotifications`,
      notificationsLoading: `${NOTIFICATION_STORE}/notificationsLoading`,
      athlete: `${ATHLETE_STORE}/athlete`,
      upgradeNotiMeta: `${NOTIFICATION_STORE}/upgradeNotiMeta`,
      systemNotiMeta: `${NOTIFICATION_STORE}/systemNotiMeta`
    }),
    isUpgradeNotification() {
      return this.title === 'Upgrade Notifications'
    }
  },
  async mounted() {
    await this.dispatcher()
  },
  methods: {
    async dispatcher(page = null) {
      !this.isUpgradeNotification && await this.$store.dispatch(`${NOTIFICATION_STORE}/getAllNotifications`, { 
          grpType: Base.userType() === 'athlete' ? 'player' : Base.userType(), 
          userId: this.$route.params.userId || JSON.parse(localStorage['user-id']),
          page: page || this.upgradePage
        })
      this.isUpgradeNotification &&  await this.$store.dispatch(`${NOTIFICATION_STORE}/renewalSystemNotification`, { 
        profileId: this.$route.params.profileId,
        page: page || this.systemPage
      })    
    },
    async onSwitchChange() {
      this.checked = !this.checked
      await this.$store.dispatch(`${ATHLETE_STORE}/updateAthlete`, {
        id: this.$route.params.profileId,
        isAutomaticRenewal: this.checked,
        slug: 'athlete'
      })
    }
  },
  watch: {
    'athlete.isAutomaticRenewal': {
      deep: true,
      immediate: true, 
      handler: async function(newVal) {
        this.checked = newVal
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
.noti-wrapper {
  padding-top: 30px;
  .noti-list-wrapper {
    border-radius: 6px;
    box-shadow: 0 8px 20px 3px rgba(0, 0, 0, 0.13);
    position: relative;
    .no-notification-class {
      position: absolute;
      top: 8px;
      left: 10px;
      color: #d73228 !important;
      text-transform: capitalize !important;
      @media only screen and (max-width: 720px) {
         left: 47px !important;
      }
    }
    .system-pagination-wrapper {
      position: absolute;
      left: 2px;
      top: -42px;
    }
    .upgrade-pagination-wrapper {
      position: absolute;
      left: 2px;
      top: -42px;
    }
    .switch-wrapper {
      position: absolute;
      right: 2%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      @media only screen and (max-width: 720px) {
        top: -105px;
        right: 26%;
        align-items: center;
        flex-direction: inherit;
      }
      p {
        margin-bottom: 4px !important;
        margin-top: 4px !important;
        @media only screen and (max-width: 720px) {
          font-size: 11px;
          margin: 0 !important;
          margin-right: 1rem !important;
        }
      }
      button {
        width: 20%;
      }
    }
    .noti-list {
      .head-divider {
        font-family: $content-font;
        font-size: 18px;
        color: #d73228;
        font-weight: 600;
        padding: 20px 25px;
        border-bottom: 1px solid #dfdfdf;
      }
      .noti-content {
        &:last-child {
          .noti-detail {
            &::before {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .noti-wrapper {
    padding-top: 50px;
    .noti-list-wrapper {
      .noti-list {
        .head-divider {
          font-size: 18px;
          padding: 20px;
        }
      }
    }
  }
}
</style>
